module.exports = __webpack_public_path__ + "img/icon-zzd.b7fde9bc.png";